import { CSSProperties } from 'react'
import { HaupLogoLoader } from './HaupLogoLoader'

interface HaupLoadingProps {
  loading?: boolean
  backgroundColor?: CSSProperties['backgroundColor']
}

/**
 * Backwards-compatible wrapper around {@link HaupLogoLoader}.
 *
 * - Passed a `backgroundColor` (route-level Suspense splash): full-screen brand
 *   splash with a white mark and a progress track.
 * - No `backgroundColor` (global LoadingContext overlay): a light translucent
 *   overlay with the brand-blue mark.
 */
export const HaupLoading = ({ loading, backgroundColor }: HaupLoadingProps): JSX.Element | null => {
  if (!loading) {
    return null
  }

  const isSplash = backgroundColor != null

  return (
    <HaupLogoLoader
      fixed
      variant={isSplash ? 'dark' : 'light'}
      showTrack={isSplash}
      backdrop={isSplash ? undefined : backgroundColor || 'rgba(255, 255, 255, 0.72)'}
    />
  )
}
